import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	profileData: {},
	tempLoginData: {},
	followedHashTags: [],
	newNotificationAlert: 0,
};

const userStore = (set: any) => ({
	...initialState,
	setProfileData: (data: any) => set((state: any) => ({ ...state, profileData: data })),
	setTempLoginData: (data: any) => set((state: any) => ({ ...state, tempLoginData: data })),
	setFollowedHashTags: (data: any) => set((state: any) => ({ ...state, followedHashTags: data })),
	setNewNotificationAlert: (data: any) =>
		set((state: any) => ({ ...state, newNotificationAlert: data })),
	resetState: () => set({ ...initialState }), // Reset function
});

const useUserStore = create(devtools(userStore));

export const {
	setProfileData,
	setTempLoginData,
	setFollowedHashTags,
	resetState,
	setNewNotificationAlert,
} = useUserStore.getState();

export default useUserStore;
